import { render, staticRenderFns } from "./supplier-list.vue?vue&type=template&id=5881a63c&"
import script from "./supplier-list.vue?vue&type=script&lang=ts&"
export * from "./supplier-list.vue?vue&type=script&lang=ts&"
import style0 from "./supplier-list.vue?vue&type=style&index=0&id=5881a63c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports